/* eslint-disable indent */
export default class Maps {
  constructor(geos, defaultLatLng) {
    //Set defaults here
    var defaultLat = parseFloat(defaultLatLng[0].trim());
    var defaultLng = parseFloat(defaultLatLng[1].trim());
    this.centerLatLng = new google.maps.LatLng(defaultLat, defaultLng);
    if (typeof defaultLatLng[2] !== 'undefined') {
      this.defaultZoom = parseInt(defaultLatLng[2].trim());
    } else {
      this.defaultZoom = 4;
    }
    this.bound = new google.maps.LatLngBounds();
    this.markers = [];
    this.infoWindows = [];
    this.locations = JSON.parse(atob(geos)).locations;
    this.locationHolder = document.querySelector('.js--location-holder');
    this.breakpoint = window.matchMedia('(max-width: 480px)');

    (this.dealerInfo = {
      selector: document.querySelector('.map-container__location-detail'),
      logo: document.querySelector('.location-detail__logo'),
      name: document.querySelector('.location-detail__name'),
      adress: document.querySelector('.location-detail__adress'),
      postal: document.querySelector('.location-detail__postal'),
      country: document.querySelector('.location-detail__country'),
      dealer: document.querySelector('.location-detail__dealer'),
    }),
      this.createMap();
    this.createMarkers();
    this.createEvents();
  }

  createMap() {
    const keys = Object.keys(this.locations);
    keys.forEach((key, index) => {
      const location = this.locations[key];
    });

    let zoomlevel = this.defaultZoom;

    this.map = new google.maps.Map(document.querySelector('.map-container'), {
      center: this.centerLatLng,
      draggable: true,
      scrollWheel: false,
      zoom: zoomlevel,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: true,
      styles: [
        {
          featureType: 'poi',
          stylers: [{ visibility: 'off', }],
        },
        {
          featureType: 'transit',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off', }],
        }
      ],
    });
    // this.goFitBounds();
  }

  createMarkers() {
    const keys = Object.keys(this.locations);
    keys.forEach((key, index) => {
      const location = this.locations[key];
      this.createMarker(location, key);
    });
  }

  /**
   * Displays a list of markers onto the map
   */
  createMarker(locationAddress, key) {
    const location = locationAddress;

    const mapContainer = document.querySelector('.map-container');

    const themeClassName = mapContainer.className.split(' ')[1];

    let color = '#007A33';

    if (themeClassName === 'is--cool-fx') {
      color = '#c36b5d';
    } else if (themeClassName === 'is--lumiforte') {
      color = '#071D49';
    } else if (themeClassName === 'is--vitapanel') {
      color = '#4CAF50';
    }

    const svg =
      // eslint-disable-next-line max-len
      `<svg xmlns="http://www.w3.org/2000/svg" width="43" height="52" viewBox="0 0 43 52"><path fill="${color}" stroke="#FFF" stroke-width="2" d="M1229.49995,259 C1223.83825,259 1218.71222,261.310453 1215.00183,265.046925 C1211.29396,268.780862 1209,273.939083 1209,279.63702 C1209,290.736324 1228.8536,307.763042 1228.8536,307.763042 C1228.8536,307.763042 1229.08062,307.957739 1229.49953,308.303425 C1229.91901,307.957963 1230.1463,307.763044 1230.1463,307.763044 C1230.1463,307.763044 1250,290.736324 1250,279.63702 C1250,273.939049 1247.70603,268.780845 1243.99816,265.046923 C1240.28774,261.310443 1235.16167,259 1229.49995,259 Z" transform="translate(-1208 -258)"/></svg>`;

    const icon = {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(32, 38), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 38), // anchor
    };

    const infowindow = new google.maps.InfoWindow({
      content: '<div class="custom-infowindow">' + location.Name + '</div>',
    });

    this.infoWindows.push(infowindow);

    // Create the new marker
    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(
        location.Geo.latitude,
        location.Geo.longitude
      ),
      map: this.map,
      icon: icon,
      title: location.Name,
      key: key,
    });

    marker.addListener('click', () => {
      this.infoWindows.forEach((infoWindow) => {
        infoWindow.close();
      });
      infowindow.open(this.map, marker);

      this.dealerInfo.selector.style.display = 'block';
      this.dealerInfo.name.innerHTML = location.Name;
      this.dealerInfo.logo.src = location.Logo;
      this.dealerInfo.adress.innerHTML = location.Street;
      this.dealerInfo.postal.innerHTML = location.PostalAndPlace;
      this.dealerInfo.country.innerHTML = location.Country;
      this.dealerInfo.dealer.value = location.Key;
      this.locationHolder.innerHTML = location.Name;

      if (this.breakpoint.matches) {
        console.log('mobiel');
        this.dealerInfo.selector.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    });

    this.markers.push(marker);
    this.bound.extend(marker.position);
  }

  goFitBounds() {
    this.map.fitBounds(this.bound); // auto-zoom
    this.map.panToBounds(this.bound); // auto-center
  }

  /**
   * Returns an Array with all locations
   */
  createEvents() {
    const searchboxForm = document.querySelector('#form-search-map');
    if(searchboxForm){
      searchboxForm.addEventListener(
        'submit',
        this.setMapCenter.bind(this),
        false
      );
    }
  }

  /**
   * Centers the map around the current selection
   * @param { any } event
   */
  setMapCenter(event) {
    event.preventDefault();

    const searchInput = document.querySelector('#form-search-map-input');
    const searchInputError = document.querySelector('.input-search-map-error');
    const service = new google.maps.places.PlacesService(this.map);
    const request = {
      query: escape(searchInput.value),
      fields: ['name', 'geometry', 'type'],
    };

    service.findPlaceFromQuery(request, (results, status) => {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        searchInputError.style.display = 'none';

        this.map.setCenter(results[0].geometry.location);
        this.addCenterMarker(results[0].geometry.location);

        switch (results[0].types[0]) {
          case 'country':
            this.map.setZoom(7);
            break;
          case 'locality':
            this.map.setZoom(13);
            break;
          case 'postal_code':
            this.map.setZoom(18);
            break;
          case 'route':
            this.map.setZoom(17);
            break;
          case 'street_address':
            this.map.setZoom(18);
            break;
          case 'point_of_interest':
            this.map.setZoom(18);
            break;
          default:
            this.map.setZoom(13);
            break;
        }
        //Nearest marker
        var nearest = this.findClosestMarker(results[0].geometry.location);
        if (nearest) {
          var bounds = new google.maps.LatLngBounds(
            results[0].geometry.location
          );
          bounds.extend(nearest.position);
          this.map.fitBounds(bounds);
          this.map.setZoom(this.map.getZoom() - 1);
        }
      } else {
        // Error message is set in de Twig template
        searchInputError.style.display = 'block';
      }
    });
  }

  addCenterMarker(location) {
    const icon = {
      url: '/public/gfx/dealer/marker-center.svg',
      scaledSize: new google.maps.Size(32, 38), // scaled size
      origin: new google.maps.Point(0, 0), // origin
      anchor: new google.maps.Point(16, 19), // anchor
    };

    // Create the new marker
    const marker = new google.maps.Marker({
      position: location,
      icon: icon,
    });

    marker.setMap(this.map);
  }

  findClosestMarker(latLng) {
    var distances = [];
    var closest = -1;
    for (var i = 0; i < this.markers.length; i++) {
      var d = google.maps.geometry.spherical.computeDistanceBetween(
        this.markers[i].position,
        latLng
      );
      distances[i] = d;
      if (closest === -1 || d < distances[closest]) {
        closest = i;
      }
    }
    if (closest !== -1 && this.markers[closest]) {
      return this.markers[closest];
    }
    return null;
  }
}
